import {
  SET_PREFERENCE_TOOLTIPS,
} from './actionTypes'

export const toggleTooltips = (active) => ({type: SET_PREFERENCE_TOOLTIPS, active: active})
